/**
 * BUBS Naturals - Performance Monitoring (Simplified)
 * Retains mobile, CLS/FID, and defensive GA/SKIO logic only
 */

(function() {
  'use strict';

  // Configuration placeholder
  const PERF_CONFIG = {
    enabled: true,
    debugMode: false
  };

  // Defensive coding - Prevent Google Analytics errors when SKIO is blocked
  function safeGetUserId() {
    try {
      if (window.bus && typeof window.bus.request === 'function') {
        return window.bus.request('user:action', 'getUserId');
      }
      return null;
    } catch (error) {
      return null;
    }
  }

  // Override Google Analytics calls to be defensive
  if (window.gtag) {
    const originalGtag = window.gtag;
    window.gtag = function(...args) {
      if (args[1] === 'user_id_update' && !safeGetUserId()) {
        return;
      }
      return originalGtag.apply(this, args);
    };
  }

  // Handle Google Tag Manager dataLayer pushes
  if (window.dataLayer) {
    const originalPush = window.dataLayer.push;
    window.dataLayer.push = function(data) {
      if (data && data.event === 'user_id_update' && !safeGetUserId()) {
        return;
      }
      return originalPush.apply(this, arguments);
    };
  }

  // Track mobile-specific metrics (basic)
  function trackMobileMetrics() {
    const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (isMobile) {
      window.addEventListener('load', function() {
        // mobile metrics tracked silently
      });
    }
  }

  // Track page visibility changes
  function trackVisibilityChanges() {
    let visibilityStart = performance.now();
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        const timeVisible = performance.now() - visibilityStart;
      } else {
        visibilityStart = performance.now();
      }
    });
  }

  // Track Cumulative Layout Shift (CLS) - optional
  function trackCumulativeLayoutShift() {
    if (!window.PerformanceObserver) return;

    try {
      const clsObserver = new PerformanceObserver(() => {});
      clsObserver.observe({ entryTypes: ['layout-shift'] });
      // No reporting; just observer initialization
    } catch (e) {
    }
  }

  // Track First Input Delay (FID) - optional
  function trackFirstInputDelay() {
    if (!window.PerformanceObserver) return;

    try {
      const fidObserver = new PerformanceObserver(() => {});
      fidObserver.observe({ entryTypes: ['first-input'] });
      // No reporting; just observer initialization
    } catch (e) {
    }
  }

  // Initialize monitoring
  function initMonitoring() {
    trackMobileMetrics();
    trackVisibilityChanges();
    trackCumulativeLayoutShift();
    trackFirstInputDelay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMonitoring);
  } else {
    initMonitoring();
  }

})();
